module.exports = __webpack_public_path__ + "img/pure_black.1aecca64.jpg";